import { Component, NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { PageNotFoundComponent } from "../society/page-not-found/page-not-found.component";
import { DealerComponent } from "./dealer/dealer.component";
import { RealEstateGridComponent } from "./real-estate-grid/real-estate-grid.component";
import { RealEstateDetailComponent } from "./real-estate-detail/real-estate-detail.component";
import { MoreAdsComponent } from './more-ads/more-ads.component';
import { ViewPropertyComponent } from './view-property/view-property.component';

const RealEstateRoutes: Routes = [
  {
    path: ":handle",
   
    children: [
      // {
      //   path: "",
      //   component: HomeComponent,
      // },
      {
        path: "",
        component: DealerComponent,
      },
      {
        path: "dealer",
        component: DealerComponent,
      },
      // {
      //   path: "list",
      //   component: RealEstateGridComponent,
      // },
      {
        path: "moreAds",
        component: MoreAdsComponent,
      },
      {
        path: "detail/:id",
        component: RealEstateDetailComponent,
      },
      {
        path: "details/:id",
        component: ViewPropertyComponent,
      },
    ],
  }, 
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(RealEstateRoutes)],
  exports: [RouterModule],
})
export class RealEstateRoutingModule {}
